import React from 'react';
import moment from 'moment-timezone';
import { useNavigate } from 'react-router-dom';
import { FaCircle } from 'react-icons/fa6';
import classes from "./MatchLiveLayoutNew.module.css";

const FT_STATUSES  = ["FT", "AET", "PEN"];
const LIVE_STATUSES = ["1H", "2H", "ET", "P", "HT", "LIVE"];

const MatchLiveLayoutNew = ({ match_details, match, index }) => {
    const navigate = useNavigate();
    const short   = match_details?.fixture?.status?.short;
    const elapsed = match_details?.fixture?.status?.elapsed;
    const extra   = match_details?.fixture?.status?.extra;

    const isFt   = FT_STATUSES.includes(short);
    const isLive = LIVE_STATUSES.includes(short);
    const showScore = isFt || isLive;

    const getStatusLabel = () => {
        if (isFt)             return { label: "Full Time",     live: false };
        if (short === "SUSP") return { label: "Suspended",     live: false };
        if (short === "PST")  return { label: "Postponed",     live: false };
        if (short === "CANC") return { label: "Cancelled",     live: false };
        if (["ABD","AWD","WO"].includes(short)) return { label: "Abandoned", live: false };
        if (short === "HT")   return { label: `Half-Time ${elapsed}\``, live: true };
        if (short === "ET")   return { label: `${elapsed}\` ET +${extra}\``, live: true };
        if (short === "P")    return { label: `Penalties ${elapsed}\``, live: true };
        if (isLive)           return { label: `${elapsed}\``, live: true };
        return null;
    };

    const status = getStatusLabel();

    return (
        <div
            className={classes.card}
            style={{ animationDelay: `${index * 0.07}s` }}
        >
            {/* League header + status */}
            <div className={classes.cardHeader}>
                <span className={classes.leagueBadge}>🏆</span>
                <span className={classes.leagueName}>{match?.league_name}</span>
                {status && (
                    status.live ? (
                        <span className={classes.statusPill}>
                            <span className={classes.statusDot} />
                            {status.label}
                        </span>
                    ) : (
                        <span className={classes.statusPillFt}>{status.label}</span>
                    )
                )}
            </div>

            {/* Teams + score */}
            <div className={classes.teamsRow}>
                <div className={classes.team}>
                    <div className={classes.logoWrap}>
                        <img src={match?.home_team_image} alt={match?.home_team_name} className={classes.teamLogo} />
                    </div>
                    <p className={classes.teamName}>{match?.home_team_name}</p>
                </div>

                <div className={classes.scoreBlock}>
                    {showScore ? (
                        <div className={classes.scoreRow}>
                            <span className={classes.score}>{match_details?.goals?.home ?? "0"}</span>
                            <span className={classes.scoreDash}>-</span>
                            <span className={classes.score}>{match_details?.goals?.away ?? "0"}</span>
                        </div>
                    ) : (
                        <>
                            <span className={classes.vsText}>VS</span>
                            <p className={classes.matchDate}>
                                {moment.utc(match?.match_date_time).local().format("ddd, DD MMM [at] hh:mm A")}
                            </p>
                        </>
                    )}
                </div>

                <div className={classes.team}>
                    <div className={classes.logoWrap}>
                        <img src={match?.away_team_image} alt={match?.away_team_name} className={classes.teamLogo} />
                    </div>
                    <p className={classes.teamName}>{match?.away_team_name}</p>
                </div>
            </div>

            {/* Action */}
            <div className={classes.actionsRow}>
                <button
                    type="button"
                    className={classes.btn}
                    onClick={() => navigate("/match-details", { state: { match_fixture_id: match?.match_fixture_id } })}
                >
                    <span className={classes.btnIcon}>📊</span>
                    View Match Details
                </button>
            </div>
        </div>
    );
};

export default MatchLiveLayoutNew;